import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { ListingCostsShape } from '../../constants/shapes';

import PaymentTimelineCard from './PaymentTimelineCard';
import PaymentTimeLineItem from './PaymentTimelineItem';
import PaymentTimelineSubtitle from './PaymentTimelineSubtitle';

const noop = () => {};

const OnCheckOut = ({
  isPricingCalculated,
  costs = {},
  currencyCode,
  isCollapsed = false,
  onSelectDates = noop
}) => {
  const totalValue = isPricingCalculated
    ? formatPrice(costs.total, currencyCode)
    : trans('book_now_modal.dates_input.label');

  return (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.on_check_out.title')}
      value={totalValue}
      collapsible
      isCollapsed={isCollapsed}
      onValueClick={!isPricingCalculated ? onSelectDates : null}
    >
      {costs?.costs?.map(cost => (
        <PaymentTimeLineItem
          key={cost.type}
          title={trans(`payment.timeline.cost.label.${cost.type}`)}
          value={cost.value}
          currencyCode={currencyCode}
          subtitle={<PaymentTimelineSubtitle paymentTo={cost.payTo} />}
        />
      ))}
    </PaymentTimelineCard>
  );
};

OnCheckOut.propTypes = {
  isPricingCalculated: PropTypes.bool.isRequired,
  costs: ListingCostsShape,
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  onSelectDates: PropTypes.func
};

export default OnCheckOut;
